module.exports = __webpack_public_path__ + "public/img/bg_01.e7c173ea.jpg";